import { useRecoilState, useRecoilValue } from 'recoil';
import { menuItemsState } from '../../store/menu.state';
import { MenuConfigSettings, MenuItem } from '../../store/menu.types';
import { warehouseSelected } from '../../store/warehouse.state';
import { WarehouseExtraSettings } from '../../store/warehouse.types';
import useUpdateWarehouseExtraSettings from './useUpdateWarehouseExtraSettings';

interface MenuFeatureSettingsOptions {
  featureKey: string;
  enabled: boolean;
  [key: string]: any;
}

const useMenuFeatureSettings = () => {
  const warehouse = useRecoilValue(warehouseSelected);
  const [menuItems, setMenuItems] = useRecoilState(menuItemsState);
  const [updateExtraSettings] = useUpdateWarehouseExtraSettings();
  const extraSettings: WarehouseExtraSettings | undefined =
    warehouse?.extraSettings;

  // TEMPORARILY DISABLED FUNCTIONALITY
  // Returning dummy functions to prevent app crashing

  // Get a feature's settings
  const getFeatureSettings = (featureKey: string) => {
    return { enabled: true };
  };

  // Check if a feature is enabled
  const isFeatureEnabled = (featureKey: string): boolean => {
    return true;
  };

  // Update feature settings
  const updateFeatureSettings = ({
    featureKey,
    ...settings
  }: MenuFeatureSettingsOptions) => {
    console.log('Feature settings update temporarily disabled');
    return Promise.resolve();
  };

  // Get menu configuration settings
  const getMenuConfigSettings = (): MenuConfigSettings => {
    return { enabled: true, menuOrder: [] };
  };

  // Save menu order configuration
  const saveMenuOrder = (items: MenuItem[]) => {
    console.log('Menu order save temporarily disabled');
    if (items?.length) {
      // Create deep copies to avoid mutating the original
      const safeItems = items.map(item => ({ ...item }));
      // Still update the local state but don't save to DB
      setMenuItems(safeItems);
    }
    return Promise.resolve();
  };

  // Apply saved menu order from settings
  const applyMenuOrderFromSettings = () => {
    console.log('Menu order application temporarily disabled');
    // No-op - just return without doing anything
    return;
  };

  return {
    getFeatureSettings,
    isFeatureEnabled,
    updateFeatureSettings,
    saveMenuOrder,
    applyMenuOrderFromSettings,
  };
};

export default useMenuFeatureSettings;
